import useTapGestureRecognizer from './useTapGestureRecognizer';

const useContextMenuGestureRecognizer = (ref: React.RefObject<HTMLElement>, eventName: string = 'contextmenu') => {
    useTapGestureRecognizer(
        ref,
        ({ location, target }) => {
            const contentMenuEvent = new MouseEvent(eventName, {
                button: 2,
                bubbles: true,
                clientX: location.x,
                clientY: location.y,
                detail: 999,
            });

            target.dispatchEvent(contentMenuEvent);
        },
        {
            requiredTouches: 2,
            maxMovementThreshold: 20,
            maxTouchDuration: 300,
        },
    );
};

export default useContextMenuGestureRecognizer;
